var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kid == null)?_c('button',{staticClass:"form",on:{"click":_vm.exportAll}},[_vm._v("Export historique")]):_c('font-awesome-icon',{staticClass:"edit",attrs:{"icon":['fas', 'file-export']},on:{"click":function($event){$event.stopPropagation();return _vm.exportKid()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }